import { db } from '../../firebase'

export const Users = db.collection('Users')

export const getUserByEmail = (email) => Users.where('email', '==', email).get()
export const getUserDoc = (collection, id) => db.collection(collection).doc(id)
